// Configuração central do assistente virtual "Ale".
// Mantém a feature isolada e fácil de ligar/desligar.

export const ALE_CONFIG = {
  // Liga/desliga o widget inteiro (pode virar variável de ambiente depois).
  enabled: true,

  // Largura (px) abaixo da qual consideramos "celular".
  // Mesmo breakpoint do tema do projeto (theme.sizes.tablet).
  mobileBreakpoint: 768,

  // Estado inicial: desktop já abre aberto; celular começa fechado.
  // (é o comportamento pedido no planejamento)
  openByDefaultOnDesktop: true,
  openByDefaultOnMobile: false,

  // Sessão salva no navegador (o backend define a validade real de 7 dias).
  sessionStorageKey: 'ale_session',
  sessionFallbackTtlMs: 7 * 24 * 60 * 60 * 1000, // usado só se o backend não mandar exp

  // Limite do campo de texto (espelha o backend).
  maxMessageLength: 500,

  // Contato humano
  whatsappPhone: '552132798800', // (21) 3279-8800
  telefone0800: '0800 021 3460',
};

// Textos da persona (fáceis de ajustar sem mexer em componente).
export const ALE_TEXTS = {
  name: 'Ale',
  launcherLabel: 'Falar com o Ale',
  headerTitle: 'Ale · Assistente virtual',
  headerSubtitle: 'Santa Casa Copacabana',
  greeting:
    'Olá! Eu sou o Ale, o assistente virtual da Santa Casa Copacabana. 😊 ' +
    'Estou aqui para te ajudar a entender os planos e tirar suas dúvidas, com calma e no seu tempo. ' +
    'Como posso te ajudar? Você pode tocar em uma das opções abaixo ou me escrever.',
  inputPlaceholder: 'Escreva sua dúvida aqui...',
  whatsappCta: 'Falar com um atendente no WhatsApp',
  errorMsg:
    'Tive um probleminha para responder agora. Tente novamente em instantes, por favor.',
};
